module.exports = __webpack_public_path__ + "static/media/easy-fast-food.48ad1215.png";